import type { NextPage } from 'next'


interface IProps {
  className?: string
  fill?: string
  direction?: 'top' | 'right' | 'bottom' | 'left'
}

const Component: NextPage<IProps> = ({ className, fill, direction }) => {
  const fillColor = fill || '#0051a4'
  let cn = className || ''
  switch(direction) {
    case 'top': cn += ' rotate-180'; break;
    case 'right': cn += ' rotate-[270deg]'; break;
    case 'bottom': cn += ''; break;
    case 'left': cn += ' rotate-90'; break;
    default: cn += ' rotate-[270deg]'; break;
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10.305" height="8.034" viewBox="0 0 10.305 8.034" className={cn}>
      <path d="M566.7,1144.378l-5.152-8.034h10.3Z" transform="translate(-561.544 -1136.344)" fill={fillColor} />
    </svg>
  )
}

export default Component
